import { render, staticRenderFns } from "./SupportTicketLauncher.vue?vue&type=template&id=3082590c&scoped=true&"
import script from "./SupportTicketLauncher.vue?vue&type=script&lang=js&"
export * from "./SupportTicketLauncher.vue?vue&type=script&lang=js&"
import style0 from "./SupportTicketLauncher.vue?vue&type=style&index=0&id=3082590c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3082590c",
  null
  
)

export default component.exports